import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';

import Skeleton from '@material-ui/lab/Skeleton';

import SearchIcon from '@material-ui/icons/Search';
import { DIMENSIONS } from '../../styles/constants';
import { useStyles } from './styles';
import TextField from '../TextField';
import { useTranslation } from 'react-i18next';

const Search = ({ searchValue, setSearchValue }) => {
	const { t } = useTranslation();
	const classes = useStyles();
	const items = useSelector(state => state.designList.items);
	const progressActive = useSelector(state => state.tabbar.progressActive);

	const handleSearch = e => {
		setSearchValue(e.target.value);
	};

	return (
		<Grid container alignItems="flex-end" className={classes.rootContainer}>
			<Grid item xs>
				{progressActive ? (
					<Skeleton height={DIMENSIONS.SKELETON_BUTTON_HEIGHT} />
				) : (
					<TextField
						placeholder={t('components.search')}
						InputLabelProps={{ className: classes.searchLabel }}
						InputProps={{
							startAdornment: (
								<InputAdornment position="start">
									<SearchIcon className={classes.searchIcon} />
								</InputAdornment>
							)
						}}
						disabled={items.length < 1}
						value={searchValue}
						onChange={handleSearch}
						label={t('components.search')}
					/>
				)}
			</Grid>
		</Grid>
	);
};

Search.propTypes = {
	searchValue: PropTypes.string.isRequired,
	setSearchValue: PropTypes.func.isRequired
};

export default Search;
